import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    guestInformation: [],
};

export const ManageGuestInformationSlice = createSlice({
    name: 'manageGuestInformation',
    initialState,
    reducers: {
        updateGuestInformation: (state, action) => {
            const { index, ...guestData } = action.payload;
            state.guestInformation = state.guestInformation.map((guest, i) =>
                i === index ? { ...guest, ...guestData } : guest
            );
        },
        setGuestInformation: (state, action) => {
            state.guestInformation = action.payload;
        },
        addGuest: (state, action) => {
            state.guestInformation.push(action.payload);
        },
        removeGuest: (state, action) => {
            state.guestInformation = state.guestInformation.filter((_, i) => i !== action.payload);
        },
        clearGuestInformation: (state) => {
            state.guestInformation = [];
        },
    },
});

export const {
    updateGuestInformation,
    setGuestInformation,
    addGuest,
    removeGuest,
    clearGuestInformation,
} = ManageGuestInformationSlice.actions;

export default ManageGuestInformationSlice.reducer;